'use client';
import '@pixi/unsafe-eval';

import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ErrorBoundary } from 'react-error-boundary';
import GlobalError from '@components/layout/global-error.jsx';
import Routes from './routes/routes.jsx';

const queryClient = new QueryClient();

const appRouter = createBrowserRouter(createRoutesFromElements(Routes()));

export function App() {
  return (
    // @ts-expect-error "idk"
    <ErrorBoundary FallbackComponent={GlobalError}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={appRouter} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
